angular.module('impactx.toolbar').component('ixToolbarTools', {
        controller: 'ToolbarToolsCtrl',
        templateUrl: 'shared/toolbar/templates/toolbar-tools.html'
    }
);